<template>
    <div>
        <v-app>
            <div class="col-md-12 mx-auto">
                <div class=" " style="border: none!important;">
                    <category-market :page-name="namePage" @category-schema="getSchema" @category-fields="getFields"
                                     ref="category" :multiAdsCat="true"></category-market>
                    <div class="col-md-12 my-0 py-0">
                        <div class="col-md-8 mx-auto my-0 py-0" v-if="fields.length > 0 && schema.category !== '' ">
                            <get-panels-number ref="number" :current="schema.category" :multiple-numbers="true"
                                               panel-type="divar_shop"></get-panels-number>
                        </div>
                    </div>
                    <input-maker ref="inputs" :ui_schema="this.ui_schema" :param="schema" class="my-0 py-0"
                                 :fields="this.fields"></input-maker>
                    <div class="col-md-12 my-0 mx-auto p-4" v-if="numbers.length > 0" v-for="item in numbers"
                         :key="item"
                         :data-number="item">
                        <v-card class="mt-3 pt-3">
                            <p class="text-center">ثبت آگهی برای
                                :{{ $refs.number.numbers.find((x) => x.id == item).phone }}</p>
                            <div class="col-md-8 mx-auto my-0 py-0">
                                <pic-selector :count="10" :ref="item" :data-num="item" :key="item"></pic-selector>
                            </div>
                            <inputs :category="schema.category" :city="schema.location.city" class="my-0 py-0"
                                    :ref="item" :has_price="$refs.category.multiFiltered.new_price || false "
                                    :key="item"></inputs>
                        </v-card>
                    </div>
                    <div class="row">
                        <div class="col-md-10 px-5 mr-2">
                            <setting-ads :market="true" :time-require="true"></setting-ads>
                            <v-btn @click="submitAds(0)" class="submit-btn float-left">
                                <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                                ثبت آگهی
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </v-app>
    </div>
</template>

<script>
import CitySelector from "@/view/pages/ads/citySelector";
import NumberSelector from "@/view/pages/ads/numberSelector";
import Inputs from "@/view/pages/ads/inputs";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import SettingAds from "@/view/pages/ads/settingAds";
import PicSelector from "@/view/pages/uploadCenter/picSelector";
import inputMaker from "@/view/pages/ads/inputMaker";
import {Axios2, Bus} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import ExtraButtons from "@/view/pages/uiBeautifier/extraButtons";
import Swal from "sweetalert2";
import GetPanelsNumber from "../agency/getPanelsNumber";
import Categoryselector from "@/view/pages/ads/categorySelector";
import CategoryMarket from "@/view/pages/ads/panels/categoryMarket";

export default {
    name: "multiMarketplace",
    components: {
        CategoryMarket,
        Categoryselector,
        GetPanelsNumber,
        ExtraButtons,
        ButtonTempl,
        TitleRibbon,
        PicSelector, SettingAds, Automatics, Inputs, NumberSelector, CitySelector, inputMaker
    },
    props: {
        ui_schema: {
            type: Array,
            default() {
                return []
            },
        },
        deActive: {
            default: false
        },
        fields: {
            type: Array,
            default() {
                return [];
            }
        },
        pageName: {
            type: String,
            default: "ارسال آگهی گروهی"
        }
    },
    data() {
        return {
            picker: '',
            cardParameters: {},
            loading: false,
            auto_pay: false,
            submitMessage: '',
            numbers: [],
            relatedCities: [],
            isNational: false,
            namePage: this.pageName,
            schema: {
                category: "",
                location: {
                    city: "",
                    neighborhood: ""
                },
                contact: {
                    chat_enabled: true,
                    hide_phone: false,
                },
            }
        }
    },
    methods: {
        getSchema: function (value) {
            this.ui_schema = value;
        },
        authenticate(title, city) {
            this.$modal.showLoading();
            $.ajax({
                url: `${url}/divar/check/title`,
                type: "POST",
                fn: this.authenticate,
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token,
                    "Content-type": 'application/json'
                },
                data: JSON.stringify({
                    "title": title,
                    "city": String(this.relatedCities.find((x)=>x.id === city).city),
                    "category": this.schema.category
                }),
                msg: false,
                error: (data) => {
                    if (data.status === 422) {
                        this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
                    } else {
                        this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
                    }
                },
                success: (data) => {
                    this.sendAds();
                }
            });

        },
        getCities() {
            Axios2.post('/divar/market/numbers/city', JSON.stringify({
                numbers: this.numbers
            })).then((response) => {
               this.relatedCities = response.data.data
            })
        },
        getFields: function (val) {
            this.fields = val;
        },
        submitAds(number = 0) {
            const data = this.schema;

            if (data.available_at === "") {

                delete data.available_at;
            }
            if (data.expire_at === "") {
                delete data.expire_at;
            }
            const main = this.numbers[number];
            if (!this.$refs.inputs.validate() || !this.$refs.number.validate() || !this.$refs[main][1].validate())
                return;

            this.authenticate(this.$refs[main][1].$data.title,main);

            let param = {
                advertise: {
                    ...data,
                    title: this.$refs[main][1].$data.title,
                    description: this.$refs[main][1].$data.description,
                    new_price: this.$refs[main][1].$data.price,
                    images: this.$refs[main][0].$data.selectedImage,
                },
                available_at: this?.$refs[main][1]?.$data?.adsTimes?.times?.starttime,
                expire_at: this?.$refs[main][1]?.$data?.adsTimes?.times?.endtime,
                auto_pay: this.auto_pay
            };

            param.advertise.contact.phone = main

            if (param.available_at === '' || param.available_at === undefined || param.available_at === null)
                delete param.available_at
            else if (param.expire_at === '' || param.expire_at === undefined || param.expire_at === null)
                delete param.expire_at

            if (param.advertise.new_price == null || param.advertise.new_price === '')
                delete param.advertise.new_price;
            if (param.advertise.images.length <= 0) {
                this.$modal.error('خطا!', 'حداقل یک عکس باید انتخاب کنید.');
                return;
            }
            $.ajax({
                url: `${url}/divar/advertise/send`,
                method: 'POST',
                fn: this.submitAds,
                params: [number],

                msg: (number + 1) >= this.numbers.length,

                redirect: {path: '/adsList/futureList'},
                headers: {
                    ACCEPT: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: Token
                },
                data: JSON.stringify(param),
            }).always(data => {
                number++;
                if (number < this.numbers.length)
                    this.submitAds(number);
            });
        },
    },
    mounted() {
        Bus.$on("selected_numbers", (val) => {
            this.numbers = val;
        });
        Bus.$on('cityInfo', (value) => {
            this.schema.location.city = value.city;
            if (value.neighborhood === '')
                delete this.schema.location.neighborhood;
            else
                this.schema.location.neighborhood = value.neighborhood;
        });

        Bus.$on('contact', (value) => {
            this.schema.contact.chat_enabled = value.chat_enabled;
            this.schema.contact.hide_phone = value.hide_phone;
            this.auto_pay = value.autoPay;
        });

        Bus.$on('category-current', (current) => {
            this.schema.category = current;
        });

        Bus.$on('national', (value) => {
            this.isNational = value
        });
    },
    watch: {
        numbers: function (val) {
            this.schema.contact.phone = val;
            if (val.length > 0)
                this.getCities();
        },
        isNational: function (val) {
            if (val === true) {
                Swal.fire({
                    title: 'خطا!',
                    text: 'شما در این دسته مجاز به اعمال آگهی نیستید.',
                    icon: "error"
                })

            }
        },

    }
}
</script>

<style scoped>

</style>